define('controller/step/datetime/EventDateTimeStep',['require','controller/step/datetime/BaseDateTimeStep','collection/TimeSlotCollection','view/controller/booking/datetime/event/TimeEventView','view/controller/booking/datetime/DateTimeStepInlineEventDateLayout'],function (require) {

    var BaseDateTimeStep = require('controller/step/datetime/BaseDateTimeStep');
    var TimeSlotCollection = require('collection/TimeSlotCollection');
    var TimeEventView = require('view/controller/booking/datetime/event/TimeEventView');
    var DateTimeStepInlineEventDateLayout = require('view/controller/booking/datetime/DateTimeStepInlineEventDateLayout');

    return BaseDateTimeStep.extend({

        _timeCollection: null,
        _timeEventView : null,

        /**
         * Inits instance
         */
        initialize: function() {
            var instance = this;
            BaseDateTimeStep.prototype.initialize.call(this);

            this.listenTo(this._bookingModel, 'change:start_date', function () {
                instance._updateCalendarCollection();
            });
            this.listenTo(this._bookingModel, 'change:selected_date', this._updateTimeCollectionNew);
            this._updateCalendarCollection();
        },

        /**
         * Inits time collection
         */
        _initTimeCollection: function () {
            this._timeCollection = new TimeSlotCollection();
        },

        /**
         * Returns time view
         *
         * @return TimeFlexibleView
         */
        _getTimeView: function () {
            var instance = this;
            this._timeEventView = new TimeEventView({
                model: this._bookingModel,
                bookingModel: this._bookingModel,
                timeCollection: this._timeCollection,
                calendarCollection: this._calendarCollection,
                timeValidateModel: this._timeValidateModel,
                clientTimeZone: this.getOption('clientTimeZone'),
                showNavigation: this._supportsTimelineNavigation,
                waitingListHelperModel: this.getOption('waitingListHelperModel'),
            });
            this._timeEventView.setCurrentYearMonth(this._currentYear, this._currentMonth);

            this.listenTo(this._timeEventView, 'prevMonth', this._prevMonth);
            this.listenTo(this._timeEventView, 'nextMonth', this._nextMonth);
            this.listenTo(this._timeEventView, 'changeMonth', this._setMonth);
            this.listenTo(this._timeEventView, 'timeChanged', function(time, date, isWaitingList){
                instance._updateSelectedTime(time, date, isWaitingList);
                instance._currentMonth = null;
            });

            return this._timeEventView;
        },

        /**
         * Returns datetime step layout
         *
         * @return DateTimeStepDefaultLayout
         */
        _getLayoutInstance: function (options) {
            return new DateTimeStepInlineEventDateLayout(options);
        },


        /**
         * When layout appears add date and time view to layout regions
         *
         * @param DateTimeStepDefaultLayout layout
         */
        showRegions: function (layout) {
            if (layout.supportsSidebar()) {
                layout.getSideBarRegion().show(this._getSideBarView());
            }

            var timeView = this._getTimeView();
            if (timeView) {
                layout.getDateTimeRegion().show(timeView);
            }

            this._resetCurrentDate();
            this._updateFirstDay();
        },


        /**
         * Perform load time collection from server if needed
         *
         * @protected
         */
        _updateTimeCollection: function () {
            //old function, not used
        },

        /**
         * Perform load time collection from server if needed
         *
         * @protected
         */
        _updateTimeCollectionNew: function () {
            this._currentDate = this._bookingModel.get('selected_date');
            if (!this._bookingModel.get('selected_date')) {
                this._timeCollection.reset();
                return;
            }

            this._fetchTimeCollection();
        },


        /**
         * Updates selected dates in date view
         *
         * @private
         */
        _updateCalendarCollection: function (date) {
            if (!date) {
                if(this._bookingModel.get('start_date')){
                    date = Date.parseMysqlDate(this._bookingModel.get('start_date'));
                } else {
                    return;
                }
            }
            BaseDateTimeStep.prototype._updateCalendarCollection.apply(this, [date]);

            if(this._timeEventView) {
                this._timeEventView.setCurrentYearMonth(this._currentYear, this._currentMonth);
            }
        },


        /**
         * Fetches time collection from server
         */
        _fetchTimeCollection: function () {
            var date = Date.parseMysqlDate(this._bookingModel.get('selected_date'));

            this._timeCollection.fetch({
                data: {
                    'from': date.getMysqlDate(),
                    'to': date.getMysqlDate(),
                    'location': this._bookingModel.get('location_id'),
                    'provider': this._bookingModel.get('provider_id'),
                    'service': this._bookingModel.get('service_id'),
                    'products': this._bookingModel.getAddons(),
                    'count': this._bookingModel.get('count')
                }
            });
        },


        /**
         * Returns start and end dates to load working calendar
         *
         * @param Date date
         * @protected
         */
        _getStartEndDate: function (date) {
            var from = new Date(date);
            from.setDate(1);
            var to = new Date(from);

            var diff = from.getDay();
            if(diff <=0 && Config.getInstance().isMondayFirstDay()){
                diff = 7;
            }
            if (Config.getInstance().isMondayFirstDay()) {
                diff--;
            }

            from.setDate(from.getDate() - diff);
            to.setDate(to.getDate() + this._daysInMonth(to));

            var diff2 = 7 - to.getDay();
            if(diff2 >= 7 && !Config.getInstance().isMondayFirstDay() ){
                diff2 = 0;
            }
            if(Config.getInstance().isMondayFirstDay() && diff2 >= 6  ){
                diff2 = (diff2==7)?0:-1;
            }
            if (!Config.getInstance().isMondayFirstDay()) {
                diff2--;
            }
            to.setDate(to.getDate() + diff2);

            return {
                'from': from,
                'to': to
            };
        },

        _daysInMonth : function (date){
            var d= new Date(date.getFullYear(), date.getMonth()+1, 0);
            return d.getDate();
        }

    });

});
